import { WEEK_COPY_INITIAL_SELECTED_DAYS } from './chunk-WKCCF5I3.mjs';
import { dateSliderHasErrorValue } from './chunk-ZYRHAISW.mjs';
import { selectCurrentTimeZone, getHourMsCore } from './chunk-PHOCK55S.mjs';
import { __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/settings/timeBasedMenuTypes.ts
var getDayWithErrorsCore = (days, state) => {
  const timeZone = selectCurrentTimeZone(state);
  const returnDays = __spreadValues({}, WEEK_COPY_INITIAL_SELECTED_DAYS);
  Object.entries(days).forEach(
    ([day, dayValue]) => {
      for (const i of dayValue.keys()) {
        const bannedRanges = dayValue.slice(0, Number(i)).map((prevMenuTypes) => [
          getHourMsCore(prevMenuTypes.startTime, timeZone),
          getHourMsCore(prevMenuTypes.endTime, timeZone)
        ]);
        const time = [
          getHourMsCore(dayValue[i].startTime, timeZone),
          getHourMsCore(dayValue[i].endTime, timeZone)
        ];
        const hasError = dateSliderHasErrorValue(time, bannedRanges);
        if (hasError) {
          returnDays[day] = true;
          return;
        }
      }
    }
  );
  return returnDays;
};

export { getDayWithErrorsCore };
